import service from '@/store/services/settings/religions-service';

const state = {
    list: {},
    religion: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, religion) => {
        state.religion = religion;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(religion => {
                commit('SET_RESOURCE', religion);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(religion => {
                commit('SET_RESOURCE', religion);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((religion) => {
                commit('SET_RESOURCE', religion);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((religion) => {
                commit('SET_RESOURCE', religion);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    religion: state => state.religion,
    dropdown: (state) => {
        return state.list.map(religion => ({
            id: religion.id,
        }));
    }
};

const religions = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default religions;
